import { cn } from '@bem-react/classname';

export const cnListItem = cn('ListItem');
